import React, { useEffect, useState } from "react";
import $ from "jquery";
import { Image as ImageIcon, Plus, Save, Trash2, Upload } from "lucide-react";
import ApiURl from "../../controllers/Api";

const DEFAULT_FORM = {
  introTitle: "ABOUT US",
  introParagraphOne:
    "S. L. GOLD was established in 1980 by Late Shri Radhey Shyam Soni (Uklana Wale), a visionary entrepreneur with a deep passion for fine jewellery. With over four decades of industry expertise, he built a strong foundation based on trust, innovation, and customer-centric craftsmanship. His legacy continues to inspire our journey as we evolve with time while preserving our core values.",
  introParagraphTwo:
    "Under his leadership, S. L. GOLD earned the reputation of being a trusted name in customized gold jewellery, known for high-quality craftsmanship and strong relationships with customers. Today, we proudly carry forward his vision, bringing elegance, tradition, and modern design together under the leadership of Jayant Soni.",
  visionTitle: "Our Vision",
  visionText:
    "To become a leading name in lightweight gold jewellery, offering timeless designs that resonate with diverse cultures and modern lifestyles across India and beyond.",
  missionTitle: "Our Mission",
  missionText:
    "To deliver superior quality gold jewellery with exceptional design, ensuring customer satisfaction through authenticity, innovation, and excellence in every creation.",
  offerTitle: "What We Offer",
  offerItems: [
    "Lightweight gold jewellery crafted with precision",
    "A collection of 300+ exclusive, trend-driven designs",
    "Certified quality and lifetime genuineness guarantee",
    "Bespoke pieces tailored to customer preferences",
    "Designs ideal for daily wear, festive occasions, and gifting",
  ],
  chooseTitle: "Why Choose Us",
  chooseItems: [
    "Legacy of 40+ Years",
    "Unmatched Design Innovation",
    "Client-Centric Approach",
    "Trusted Quality & Certification",
    "Commitment to Craftsmanship",
  ],
  quoteTitleLineOne: "Crafted with trust.",
  quoteTitleLineTwo: "Cherished for generations.",
  quoteTextOne:
    "At S. L. GOLD, we don't just create jewellery - we craft stories, emotions, and timeless beauty.",
  quoteTextTwo:
    "Our dedication to excellence ensures that every piece reflects sophistication, tradition, and enduring value.",
  highlightLabels: [
    "40+ Years\nof Legacy",
    "Certified\nQuality",
    "300+ Exclusive\nDesigns",
    "Customer\nFirst",
    "Perfect for Every\nOccasion",
  ],
};

export default function AdminAboutPage() {
  const [form, setForm] = useState(DEFAULT_FORM);
  const [files, setFiles] = useState({ hero_image: null, quote_image: null });
  const [previews, setPreviews] = useState({ hero_image: "", quote_image: "" });
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await $.getJSON(`${ApiURl}getAboutPage.php`);
        if (!response?.success || !response?.data) return;

        const data = response.data;
        setForm((prev) => ({
          ...prev,
          ...Object.fromEntries(
            Object.entries(data).filter(([, value]) => value !== null && value !== "")
          ),
          offerItems: Array.isArray(data.offerItems) && data.offerItems.length ? data.offerItems : prev.offerItems,
          chooseItems: Array.isArray(data.chooseItems) && data.chooseItems.length ? data.chooseItems : prev.chooseItems,
          highlightLabels:
            Array.isArray(data.highlightLabels) && data.highlightLabels.length
              ? data.highlightLabels
              : prev.highlightLabels,
        }));
        setPreviews({
          hero_image: data.heroImage || "",
          quote_image: data.quoteImage || "",
        });
      } catch (error) {
        console.error("Error loading About Us settings:", error);
        setMessage("Could not load saved About Us settings.");
      }
    };

    fetchSettings();
  }, []);

  const updateForm = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const updateList = (field, index, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: prev[field].map((item, i) => (i === index ? value : item)),
    }));
  };

  const addListItem = (field, value = "") => {
    setForm((prev) => ({ ...prev, [field]: [...prev[field], value] }));
  };

  const removeListItem = (field, index) => {
    setForm((prev) => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index),
    }));
  };

  const handleImageChange = (field) => (event) => {
    const file = event.target.files?.[0] || null;
    setFiles((prev) => ({ ...prev, [field]: file }));
    setPreviews((prev) => ({
      ...prev,
      [field]: file ? URL.createObjectURL(file) : prev[field],
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setMessage("");

    const payload = new FormData();
    [
      "introTitle",
      "introParagraphOne",
      "introParagraphTwo",
      "visionTitle",
      "visionText",
      "missionTitle",
      "missionText",
      "offerTitle",
      "chooseTitle",
      "quoteTitleLineOne",
      "quoteTitleLineTwo",
      "quoteTextOne",
      "quoteTextTwo",
    ].forEach((field) => payload.append(field, form[field] || ""));

    payload.append("offerItems", JSON.stringify(form.offerItems));
    payload.append("chooseItems", JSON.stringify(form.chooseItems));
    payload.append("highlightLabels", JSON.stringify(form.highlightLabels));
    if (files.hero_image) payload.append("hero_image", files.hero_image);
    if (files.quote_image) payload.append("quote_image", files.quote_image);

    try {
      const response = await $.ajax({
        url: `${ApiURl}updateAboutPage.php`,
        type: "POST",
        data: payload,
        processData: false,
        contentType: false,
        dataType: "json",
      });

      if (response?.success) {
        setMessage("About Us page updated successfully.");
        setFiles({ hero_image: null, quote_image: null });
      } else {
        setMessage(response?.message || "Failed to update About Us page.");
      }
    } catch (error) {
      console.error("Error saving About Us settings:", error);
      setMessage("Server error while saving About Us page.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-about-page-luxury min-h-screen w-full overflow-x-hidden bg-[#F7EFE7] p-3 font-[Kanit] text-[#2B0000] sm:p-5 lg:p-7">
      <div className="mx-auto mb-6 max-w-[1500px] rounded-[24px] border border-[#d8c6b7] bg-[radial-gradient(circle_at_top_left,rgba(212,175,55,0.14),transparent_34%),linear-gradient(135deg,#fffaf5,#f2e6dc)] p-5 shadow-[0_18px_48px_rgba(43,0,0,0.08)] sm:p-6">
        <h1 className="font-serif text-3xl font-medium tracking-tight text-[#2B0000] sm:text-4xl">About Us Page</h1>
        <p className="mt-2 max-w-3xl text-sm leading-6 text-[#6f5e57]">
          Edit the About Us content, showcase images, mission, vision, feature lists and bottom highlights.
        </p>
      </div>

      {message && (
        <div className="mx-auto mb-6 max-w-[1500px] rounded-2xl border border-[#d4af37]/25 bg-[#fff7e6] px-4 py-3 text-sm font-semibold text-[#7d5a19] shadow-[0_10px_25px_rgba(43,0,0,0.05)]">
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="mx-auto max-w-[1500px] space-y-7">
        <Section title="About Banner">
          <TextInput label="Main Heading" value={form.introTitle} onChange={(value) => updateForm("introTitle", value)} />
          <TextArea label="First Paragraph" rows={5} value={form.introParagraphOne} onChange={(value) => updateForm("introParagraphOne", value)} />
          <TextArea label="Second Paragraph" rows={5} value={form.introParagraphTwo} onChange={(value) => updateForm("introParagraphTwo", value)} />
          <ImageField label="About Banner Image" preview={previews.hero_image} onChange={handleImageChange("hero_image")} />
        </Section>

        <Section title="Mission And Vision">
          <div className="grid gap-4 md:grid-cols-2">
            <TextInput label="Vision Title" value={form.visionTitle} onChange={(value) => updateForm("visionTitle", value)} />
            <TextInput label="Mission Title" value={form.missionTitle} onChange={(value) => updateForm("missionTitle", value)} />
            <TextArea label="Vision Text" value={form.visionText} onChange={(value) => updateForm("visionText", value)} />
            <TextArea label="Mission Text" value={form.missionText} onChange={(value) => updateForm("missionText", value)} />
          </div>
        </Section>

        <Section title="Offer And Choose Lists">
          <TextInput label="Offer Title" value={form.offerTitle} onChange={(value) => updateForm("offerTitle", value)} />
          <ListEditor label="Offer Items" field="offerItems" items={form.offerItems} onAdd={addListItem} onRemove={removeListItem} onChange={updateList} />
          <TextInput label="Choose Title" value={form.chooseTitle} onChange={(value) => updateForm("chooseTitle", value)} />
          <ListEditor label="Why Choose Us Items" field="chooseItems" items={form.chooseItems} onAdd={addListItem} onRemove={removeListItem} onChange={updateList} />
        </Section>

        <Section title="Crafted With Trust">
          <div className="grid gap-4 md:grid-cols-2">
            <TextInput label="Quote Title Line 1" value={form.quoteTitleLineOne} onChange={(value) => updateForm("quoteTitleLineOne", value)} />
            <TextInput label="Quote Title Line 2" value={form.quoteTitleLineTwo} onChange={(value) => updateForm("quoteTitleLineTwo", value)} />
          </div>
          <TextArea label="Quote Paragraph 1" value={form.quoteTextOne} onChange={(value) => updateForm("quoteTextOne", value)} />
          <TextArea label="Quote Paragraph 2" value={form.quoteTextTwo} onChange={(value) => updateForm("quoteTextTwo", value)} />
          <ImageField label="Crafted With Trust Image" preview={previews.quote_image} onChange={handleImageChange("quote_image")} />
        </Section>

        <Section title="Bottom Highlights">
          <ListEditor
            label="Highlight Labels"
            field="highlightLabels"
            items={form.highlightLabels}
            multiline
            onAdd={addListItem}
            onRemove={removeListItem}
            onChange={updateList}
          />
        </Section>

        <button
          type="submit"
          disabled={saving}
          className="inline-flex items-center gap-2 rounded-xl bg-[#2B0000] px-5 py-3 text-sm font-semibold text-[#f4dfae] shadow-[0_12px_28px_rgba(43,0,0,0.16)] transition hover:-translate-y-0.5 hover:bg-[#4A090B] disabled:cursor-not-allowed disabled:bg-[#b7a69b] disabled:text-white"
        >
          <Save className="h-4 w-4" />
          {saving ? "Saving..." : "Save About Us Page"}
        </button>
      </form>

      <style>{`
        .admin-about-page-luxury {
          background:
            radial-gradient(circle at 7% 0%, rgba(212,175,55,.10), transparent 28%),
            radial-gradient(circle at 95% 92%, rgba(43,0,0,.04), transparent 30%),
            #F7EFE7;
        }

        .admin-about-page-luxury input,
        .admin-about-page-luxury textarea,
        .admin-about-page-luxury button {
          font: inherit;
        }

        .admin-about-page-luxury ::selection {
          color: #fff7e7;
          background: #7a3131;
        }

        .admin-about-page-luxury * {
          scrollbar-width: thin;
          scrollbar-color: rgba(143,111,56,.5) rgba(212,175,55,.07);
        }

        .admin-about-page-luxury *::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .admin-about-page-luxury *::-webkit-scrollbar-track {
          background: rgba(212,175,55,.07);
        }

        .admin-about-page-luxury *::-webkit-scrollbar-thumb {
          border: 2px solid transparent;
          border-radius: 999px;
          background: rgba(143,111,56,.5);
          background-clip: padding-box;
        }

        @media (max-width: 640px) {
          .admin-about-page-luxury {
            padding: 10px;
          }
        }
      `}</style>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="rounded-[24px] border border-[#d8c6b7] bg-[#fffaf5] p-4 shadow-[0_18px_48px_rgba(43,0,0,0.07)] sm:p-6">
      <h2 className="mb-5 border-b border-[#e3d6cb] pb-4 font-serif text-2xl font-medium text-[#2B0000]">{title}</h2>
      <div className="space-y-4">{children}</div>
    </section>
  );
}

function TextInput({ label, value, onChange }) {
  return (
    <label className="block">
      <span className="mb-2 block text-sm font-semibold text-[#4a352f]">{label}</span>
      <input
        type="text"
        value={value || ""}
        onChange={(event) => onChange(event.target.value)}
        className="w-full rounded-xl border border-[#d6c4b5] bg-white px-4 py-3 text-sm text-[#2B0000] shadow-sm outline-none transition placeholder:text-[#8d7b73] focus:border-[#c59a4a] focus:ring-4 focus:ring-[#d4af37]/10"
      />
    </label>
  );
}

function TextArea({ label, value, onChange, rows = 4 }) {
  return (
    <label className="block">
      <span className="mb-2 block text-sm font-semibold text-[#4a352f]">{label}</span>
      <textarea
        rows={rows}
        value={value || ""}
        onChange={(event) => onChange(event.target.value)}
        className="w-full rounded-xl border border-[#d6c4b5] bg-white px-4 py-3 text-sm text-[#2B0000] shadow-sm outline-none transition placeholder:text-[#8d7b73] focus:border-[#c59a4a] focus:ring-4 focus:ring-[#d4af37]/10"
      />
    </label>
  );
}

function ListEditor({ label, field, items, onAdd, onRemove, onChange, multiline = false }) {
  return (
    <div>
      <div className="mb-2 flex items-center justify-between">
        <span className="text-sm font-semibold text-[#4a352f]">{label}</span>
        <button
          type="button"
          onClick={() => onAdd(field)}
          className="inline-flex items-center gap-2 rounded-xl bg-[#2B0000] px-3 py-2 text-xs font-semibold text-[#f4dfae] shadow-sm transition hover:bg-[#4A090B]"
        >
          <Plus className="h-4 w-4" />
          Add
        </button>
      </div>

      <div className="space-y-2">
        {items.map((item, index) => (
          <div key={index} className="grid gap-2 md:grid-cols-[1fr_auto]">
            {multiline ? (
              <textarea
                rows={2}
                value={item || ""}
                onChange={(event) => onChange(field, index, event.target.value)}
                className="w-full rounded-xl border border-[#d6c4b5] bg-white px-4 py-3 text-sm text-[#2B0000] shadow-sm outline-none transition placeholder:text-[#8d7b73] focus:border-[#c59a4a] focus:ring-4 focus:ring-[#d4af37]/10"
                placeholder="Use Enter for line break"
              />
            ) : (
              <input
                type="text"
                value={item || ""}
                onChange={(event) => onChange(field, index, event.target.value)}
                className="w-full rounded-xl border border-[#d6c4b5] bg-white px-4 py-3 text-sm text-[#2B0000] shadow-sm outline-none transition placeholder:text-[#8d7b73] focus:border-[#c59a4a] focus:ring-4 focus:ring-[#d4af37]/10"
              />
            )}
            <button
              type="button"
              onClick={() => onRemove(field, index)}
              className="rounded-xl border border-red-200 bg-[#fff4f1] p-2 text-red-600 transition hover:bg-red-600 hover:text-white"
              aria-label={`Remove ${label}`}
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

function ImageField({ label, preview, onChange }) {
  return (
    <div className="rounded-[20px] border border-[#decfc3] bg-[linear-gradient(145deg,#fffaf5,#f3e8dd)] p-4 shadow-[0_14px_36px_rgba(43,0,0,0.05)]">
      <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-[#2B0000]">
        <ImageIcon className="h-4 w-4 text-[#8f6f38]" />
        {label}
      </div>
      <div className="mb-4 h-64 overflow-hidden rounded-[18px] border border-[#d8c6b7] bg-[#fbf3eb] shadow-inner">
        {preview ? (
          <img src={preview} alt={label} className="h-full w-full bg-[#fffaf5] object-contain" />
        ) : (
          <div className="flex h-full items-center justify-center text-sm text-[#9b877e]">
            No image selected
          </div>
        )}
      </div>
      <label className="inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl border border-[#d6c4b5] bg-white px-4 py-3 text-sm font-semibold text-[#2B0000] shadow-sm transition hover:border-[#c59a4a] hover:bg-[#fff7ed]">
        <Upload className="h-4 w-4" />
        Upload Image
        <input type="file" accept="image/*" onChange={onChange} className="hidden" />
      </label>
    </div>
  );
}